import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Breadcrumbs, Crumb, Flex } from "@ebscois/react-component-library";
import { StyledSpan } from "./_.styled";

const ContentBreadcrumb = ({
  onBreadcrumbClick,
  breadcrumbData,
  title,
  firstSectionReference,
  urlFragment,
  currentDmxDrugTab,
}) => {
  const location = useLocation();
  const history = useHistory();
  const size = breadcrumbData ? breadcrumbData.length : -1;

  const lastIndex = size - 1;

  // use currying pass the reference without using anonymous function
  const handleBreadcrumbClick = (reference) => (evt) => {
    // prevent default link behavior so we can manually handle navigation
    evt.preventDefault();
    onBreadcrumbClick(reference, location.pathname, history);
  };

  // First crumb is topic title. Topic title links back to first section scrolled to top.
  // Then map through breadcrumbData to create other crumbs.
  // Second crumb is the h2.
  // The last crumb is not a link (plain text).
  return (
    <>
      {breadcrumbData?.length > 0 && (
        <Flex container span>
          <Flex
            cell
            style={{
              alignItems: "center",
            }}
          >
            {currentDmxDrugTab && <StyledSpan>{currentDmxDrugTab}</StyledSpan>}
            <span>
              <Breadcrumbs aria-label={null}>
                <Crumb
                  text={<span>{title.label}</span>}
                  href={`${urlFragment + (firstSectionReference ?? "")}`}
                  onLinkClick={handleBreadcrumbClick(
                    firstSectionReference ?? ""
                  )}
                />
                {breadcrumbData.map((crumb, index) => (
                  <Crumb
                    key={crumb.reference}
                    text={<span>{crumb.title}</span>}
                    href={
                      index !== lastIndex
                        ? `${urlFragment + crumb.reference}`
                        : undefined
                    }
                    onLinkClick={handleBreadcrumbClick(crumb.reference)}
                  />
                ))}
              </Breadcrumbs>
            </span>
          </Flex>
        </Flex>
      )}
    </>
  );
};

ContentBreadcrumb.displayName = "ContentBreadcrumb";

export default ContentBreadcrumb;
